module.exports = __webpack_public_path__ + "static/slider5-6ece5c1113347becfebbebe80bb5165e.jpg";